import { changeAppRoot, appInitialized, reset } from './app';
import { logout, providerLogin, providerLoginHealthSummary } from './authAction';
import getGroupMember from './digitalCardAction';
import changeLocale from './languageAction';
import getSupportedLanguages from './supportedLanguagesAction';

export default {
  changeAppRoot,
  appInitialized,
  logout,
  getGroupMember,
  changeLocale,
  reset,
  providerLogin,
  providerLoginHealthSummary,
  getSupportedLanguages,
};
